import { defaultTheme } from '../../../../defaultTheme'
import { ComponentTheme } from './types'

// Basically matching styles of rc-tooltip
const muiTooltipTheme: ComponentTheme<'MuiTooltip'> = {
  styleOverrides: {
    arrow: {
      '&::before': {
        backgroundColor: defaultTheme().colors.tooltipBackground
      },
      // Hack to compensate for a rounding error that resulted in a 1px
      // gap between tooltip and arrow
      '[data-popper-placement*="left"] &': { marginRight: 'calc(-0.71em + 1px) !important' },
      '[data-popper-placement*="right"] &': { marginLeft: 'calc(-0.71em + 1px) !important' }
    },
    tooltip: {
      backgroundColor: defaultTheme().colors.tooltipBackground,
      borderRadius: '4px',
      padding: '8px',
      lineHeight: '18px',
      fontSize: '14px',
      opacity: '0.9 !important'
    }
  }
}

export default muiTooltipTheme
